module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-reason-4-8cc0d07b7088ba7f9340e5d11589a588.jpg";